import { memo, useMemo, useRef } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Box } from '@lyearn/ui';
import { FormRefType } from '@/components/Form';
import { Modal } from '@/components/Modals';
import { ModalVariant } from '@/components/Modals/types';
import AttachMindsetsGoalsSkillsForm, {
  AttachMindsetsGoalsSkillsFormValues,
} from '@/modules/corporate/modules/course/views/CourseBuilder/components/SidebarDetails/Settings/components/Dialogs/components/AttachMindsetsGoalsSkillsForm';
import { UpdateArticleInput } from '@/types/schema';

import { DialogProps } from '../types';

const AttachMindsetsGoalsSkillsInArticle: React.FC<DialogProps> = ({
  content,
  onSubmit,
  onClose,
}) => {
  const { t } = useTranslation();
  const formRef: FormRefType<AttachMindsetsGoalsSkillsFormValues> = useRef(null);

  const initialValues = useMemo<AttachMindsetsGoalsSkillsFormValues>(() => {
    return {
      mindsetIds: content?.mindsetIds ?? [],
      goalIds: content?.goalIds ?? [],
      skillIds: content?.skillIds ?? [],
    };
  }, [content]);

  const onSubmitHandler = async (data: AttachMindsetsGoalsSkillsFormValues) => {
    await onSubmit?.({
      mindsetIds: { set: data.mindsetIds },
      goalIds: { set: data.goalIds },
      skillIds: { set: data.skillIds },
    } satisfies UpdateArticleInput);
    onClose();
  };

  return (
    <Modal
      action={{
        onSubmit: () => formRef.current?.submitForm(),
        text: t('Common:Actions.SaveChanges'),
      }}
      header={{
        title: 'Attach Mindsets, Goals & Skills',
        description: 'Connect your article with productivity metrics',
      }}
      variant={ModalVariant.Wide}
      onClose={onClose}>
      <Box className="px-32 pb-32 pt-16">
        <AttachMindsetsGoalsSkillsForm
          formRef={formRef}
          initialValues={initialValues}
          onSubmit={onSubmitHandler}
        />
      </Box>
    </Modal>
  );
};

export default memo(AttachMindsetsGoalsSkillsInArticle);
